module.exports = __webpack_public_path__ + "img/banner_yinxiang.b241177c.png";